import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom'; // react-router-dom에서 useNavigate 가져오기
import axios from 'axios';
import styles from './Create_quest.module.css'; // CSS Module import

import { format } from 'date-fns';


import HeaderSection from '../all_pages/HeaderSection';

import Group_of_characters from '../../assets/Group_of_characters.svg'; // 로고 이미지 import
import loading from '../../assets/Loading.svg'; // 로고 이미지 import

const apiUrl = process.env.REACT_APP_API_URL;  // 환경 변수로 API URL 불러오기


const QuestCreatePage = () => {
  const [step, setStep] = useState(1);  // 현재 단계
  const [topSkills, setTopSkills] = useState([]);  // 상위 3가지 유형 저장
  const [selectedQuests, setSelectedQuests] = useState([]);  // 랜덤으로 선택된 퀘스트 저장
  const [goal, setGoal] = useState('');  // 퀘스트 목표 저장
  const [selectedTag, setSelectedTag] = useState(null);  // 선택된 태그 저장
  const [isInputDisabled, setIsInputDisabled] = useState(false);  // 입력 비활성화 상태
  const [isLoading, setIsLoading] = useState(false);  // 로딩 상태
  const [gptResult, setGptResult] = useState(null);  // GPT로 생성된 데이터

  const [questDetails, setQuestDetails] = useState([]); // 데이터베이스에서 가지고 온 상세 내용

  const [questTitle, setQuestTitle] = useState('');  // 선택된 퀘스트 타이틀 저장

  const [questId, setQuestId] = useState(null);  // 퀘스트 ID 상태 관리
  const [questDetailId, setQuestDetailId] = useState(null);  // 퀘스트 세부 ID 상태 관리

  const [editableQuests, setEditableQuests] = useState([]); // 수정 가능한 21일차 퀘스트
  const [isGptQuest, setIsGptQuest] = useState(false); // GPT 퀘스트 여부

  const navigate = useNavigate(); // useNavigate 훅 설정

  const [showExitModal, setShowExitModal] = useState(false); // 페이지 나가기 확인 모달 상태 추가

  const [showCreatePage, setShowCreatePage] = useState(false); // 생성 페이지 활성화 여부

  const [isError, setIsError] = useState(false);  // 오류 발생 상태


    // 뒤로가기 클릭 시 모달을 띄우는 함수
    const handleBackClick = () => {
      setShowExitModal(true);
    };
  
    // 모달에서 '네' 클릭 시 페이지 이동
    const handleConfirmExit = () => {
      setShowExitModal(false);
      navigate('/questpage'); // 퀘스트 페이지로 이동
    };
  
    // 모달에서 '아니요' 클릭 시 모달 닫기
    const handleCancelExit = () => {
      setShowExitModal(false);
    };


  // 상위 3가지 유형을 가져오는 함수
  // 상위 3가지 유형을 가져오는 함수
  const fetchTopSkills = async () => {
    // 캐시에서 상위 3가지 유형을 먼저 확인
    // const cachedSkills = localStorage.getItem('topSkills');
    const cacheTime = localStorage.getItem('cacheTime');
    const now = new Date().getTime();
  
    // 캐시가 있고 1시간 이내에 저장된 경우, 캐시된 데이터를 사용
    // if (cachedSkills && cacheTime && (now - cacheTime < 3600000)) {
    //   const parsedSkills = JSON.parse(cachedSkills).map(skillData => skillData[0]);
    //   if (parsedSkills && parsedSkills.length > 0) {
    //     console.log('Using cached top skills:', parsedSkills);  // 캐시된 데이터 출력
    //     return parsedSkills;
    //   }
    // }
    const cachedSkills = JSON.parse(localStorage.getItem('topSkills'));
    if (Array.isArray(cachedSkills) && cachedSkills.length > 0) {
      const parsedSkills = cachedSkills.map(skillData => Array.isArray(skillData) ? skillData[0] : skillData);
      console.log('Using cached top skills:', parsedSkills);
      return parsedSkills;
    }
      

    // 캐시가 없거나 만료된 경우, 서버로부터 데이터 요청
    const token = localStorage.getItem('accessToken');
  
    try {
      const response = await axios.get(`${apiUrl}/aptitude_test/user-top-skills/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
  
      const topSkills = response.data.map(skillData => skillData[0]); // 스킬 이름만 가져오기
  
      if (topSkills && topSkills.length > 0) {
        console.log('Fetched top skills:', topSkills);  // 서버로부터 받은 데이터 출력
        localStorage.setItem('topSkills', JSON.stringify(response.data));  // 원본 데이터를 로컬스토리지에 저장
        localStorage.setItem('cacheTime', now);  // 캐시된 시간 기록
        return topSkills;
      } else {
        console.log('No top skills found for this user.');
        return [];
      }
    } catch (error) {
      console.error('Error fetching top skills:', error);  // 에러 로그 출력
      return [];
    }
  };
  
  

  // 페이지가 로드될 때 상위 3가지 유형을 가져옴
  useEffect(() => {
    const loadSkills = async () => {
      const skills = await fetchTopSkills();
      setTopSkills(skills);  // 상태 업데이트
      console.log('Loaded top skills:', skills);  // 콘솔에 로드된 스킬 출력
    };
  
    loadSkills();
  }, []);
  // useEffect로 상태가 변경된 후 확인
  useEffect(() => {
    if (questId && questDetailId) {
      console.log('questId:', questId);  // 상태가 업데이트된 후의 값
      console.log('questDetailId:', questDetailId);
    }
  }, [questId, questDetailId]);  // questId 또는 questDetailId가 변경될 때마다 실행

  // 목표 입력 시 상태 업데이트
  const handleInputChange = (e) => {
    setGoal(e.target.value);
  };
  //////////////////////////////////////////////// 사용자가 인풋폼에 값을 하는 상태 업데이트 끝.



//// GPT로 생성한 퀘스트 수정 기능 구현

  // questDetails가 업데이트되면 editableQuests를 questDetails로 설정
  useEffect(() => {
    if (questDetails && questDetails.length > 0) {
      setEditableQuests(questDetails); // questDetails로 초기화
    }
  }, [questDetails]);





  const handleTagClick = (quest) => {
    if (quest === selectedTag) {
      // 버튼이 다시 클릭되어 취소될 때, selectedTag를 null로 설정하고 입력 필드 활성화
      console.log('Tag unselected:', selectedTag);
      setSelectedTag(null);
      setQuestTitle('');  // 선택 해제 시 제목을 초기화
    } else {
      setSelectedTag(quest);
      setQuestTitle(quest);  // 선택된 퀘스트 제목 저장
      setGoal('추천 퀘스트를 선택하셨습니다.');
      console.log('Tag selected:', quest); // 선택된 태그 값 로그 출력
      setIsInputDisabled(true);
    }
  };
  
  // selectedTag가 null로 변경되면 goal을 빈 값으로 초기화하고 입력 필드 활성화
  useEffect(() => {
    if (selectedTag === null) {
      setGoal(''); // goal 값 초기화
      setIsInputDisabled(false); // 입력 필드 활성화
    }
  }, [selectedTag]);

  // 퀘스트 수정 시 호출되는 함수
  const handleQuestEdit = (index, field, value) => {
    const updatedQuests = [...editableQuests];
    updatedQuests[index][field] = value; // 필드값 업데이트
    setEditableQuests(updatedQuests); // 수정된 내용 저장
  };

// '다음으로' 버튼 클릭 시 처리할 로직
const handleNextClick = async () => {  
  if (step === 1) {
    setIsLoading(true);  // 로딩 상태 시작
    setStep(2);  // 로딩 페이지로 이동

    try {

      console.log("최종 내용: ", goal); // 초기화 전 상태 확인
      // setGoal(""); // 상태 초기화
      console.log("진짜 최종 내용: ", goal); // 초기화 후 상태 확인







      const token = localStorage.getItem('accessToken');  // 토큰이 저장된 경우 가져오기
      if (goal && selectedTag) {
        // 1. 선택한 퀘스트에 맞는 데이터를 가져오는 API 호출 (퀘스트 선택)
        const response = await axios.get(`${apiUrl}/quest/user-quest/${selectedTag}/`, {
          headers: { Authorization: `Bearer ${token}` } // 필요한 경우 헤더에 토큰 추가
        });
        const questData = response.data; // 반환 값 

        console.log("데이터확인하기 ", questData);

        // 디버그 로그: quest_id와 quest_title 출력
        console.log(`Quest ID: ${questData.quest_id}, Quest Title: ${questData.title}`);

        // 퀘스트 데이터를 상태에 저장
        setQuestDetails(questData.details);  // 퀘스트 세부 내용 저장
        setQuestTitle(questData.title);  // 선택된 퀘스트 타이틀 저장
        setQuestId(questData.quest_id);  // 퀘스트 ID를 상태에 저장

        // 디버그 로그: first_quest_detail_id 출력
        console.log(`First Quest Detail ID: ${questData.first_quest_detail_id}`);

        // first_quest_detail_id를 상태에 저장
        setQuestDetailId(questData.first_quest_detail_id);  // quest_detail_id에 저장된 첫 번째 세부 퀘스트 ID 저장

        setIsGptQuest(false);  // 기존 퀘스트임을 설정 (지정 퀘스트임을 설정)
        setIsLoading(false);  // 로딩 상태 종료
        setStep(3);  // 결과 페이지로 이동
      } 
      else if (goal && !selectedTag) {
        // 2. 목표 값을 백엔드로 보내는 로직 (사용자가 직접 입력한 경우)
        await sendGPTQuestLogToBackend();  // GPT API로 목표 값 전송
        setQuestTitle(goal);  // 사용자가 입력한 목표를 퀘스트 타이틀로 저장
        setIsGptQuest(true);  // GPT 퀘스트임을 설정 (사용자 입력 퀘스트)
        setIsLoading(false);  // 로딩 상태 종료
        setStep(3);  // 결과 페이지로 이동
      } else {
        setIsLoading(false);  // 입력 값이 없을 경우 로딩 종료
        console.error('목표 값이나 선택된 퀘스트가 없습니다.');
      }
    } catch (error) {
      console.error('Error processing quest:', error);
      setIsLoading(false);
    }
  } else if (step === 3) {
    try {
      const token = localStorage.getItem('accessToken');  // 토큰이 저장된 경우 가져오기

      if (isGptQuest) {
        // GPT로 생성된 퀘스트 저장 로직
        const questSaveResponse = await axios.post(`${apiUrl}/quest/save/`, {
          title: questTitle,
          details: editableQuests || [],  // 수정된 퀘스트 내용을 포함 (undefined 방지)
        }, {
          headers: { Authorization: `Bearer ${token}` }
        });

        const savedQuestId = questSaveResponse.data.quest_id;
        const savedFirstQuestDetailId = questSaveResponse.data.first_quest_detail_id;

        // 디버그 로그: 저장된 퀘스트 ID와 첫 번째 세부 퀘스트 ID 출력
        console.log(`Saved Quest ID: ${savedQuestId}, Saved First Quest Detail ID: ${savedFirstQuestDetailId}`);

        setQuestId(savedQuestId);
        setQuestDetailId(savedFirstQuestDetailId);
        await saveQuestLog(savedQuestId, savedFirstQuestDetailId);
      } else {
        if (!questId || !questDetailId) {
          throw new Error('퀘스트 ID 또는 1일차 세부 퀘스트의 ID가 누락되었습니다.');
        }

        // 디버그 로그: questId와 questDetailId 출력
        console.log(`Quest ID: ${questId}, Quest Detail ID: ${questDetailId}`);

        await saveQuestLog(questId, questDetailId);
      }
    } catch (error) {
      console.error('Error saving quest log:', error);
    }
  }
};




// 로그 저장을 위한 별도의 함수 정의
const saveQuestLog = async (questId, questDetailId) => {
  const token = localStorage.getItem('accessToken');
  
  try {
      const logResponse = await axios.post(`${apiUrl}/quest/log-quest/`, {
          quest_id: questId,  // 퀘스트 ID
          quest_detail_id: questDetailId,  // 1일차 퀘스트 상세 ID
          quest_day: 1,  // 1일차 로그 저장
          status: 'in_progress'  // 상태는 진행 중
      }, {
          headers: { Authorization: `Bearer ${token}` }
      });

      if (logResponse.status === 200 || logResponse.status === 201) {
          console.log('1일차 로그 저장 성공');
          setStep(4);  // 4번째 페이지로 이동

          // formattedDate 값 확인을 위해 로그 추가
          const formattedDate = format(new Date(), 'yyyy-MM-dd');
          console.log('Formatted Date:', formattedDate); // 확인용 로그

          // localStorage에서 퀘스트 항목 제거 전 값 확인
          const storedItem = localStorage.getItem(`quests_${formattedDate}`);
          console.log('Stored Item before removal:', storedItem); // 삭제 전 확인

          // 저장된 아이템이 있을 경우만 삭제
          if (storedItem) {
              localStorage.removeItem(`quests_${formattedDate}`);
              console.log('Item removed from localStorage');
          } else {
              console.log('No item found to remove');
          }


      } else {
          console.error('1일차 로그 저장 실패:', logResponse.statusText);
      }
  } catch (error) {
      console.error('Error saving quest log:', error);
  }
};

  //// 네비게이션 이동
    // 다음으로 버튼 클릭 시 main 페이지로 이동하는 함수 정의
    const handleFinishClick = () => {
      navigate('/main'); // /main 경로로 네비게이션
    };


  //////////////////////////////////////////////// 다음으로 버튼 처리 로직 끝. 



  //// 다음으로 버튼 2 (사용자 맞춤형 퀘스트를 생성하고 나서 값 저장하기)
  const handleSaveAndNextClick = async () => {
    try {
      if (isGptQuest) {
        const token = localStorage.getItem('accessToken');  // 토큰이 저장된 경우 가져오기
        const response = await axios.post(
          `${apiUrl}/api/save-quest/`, // 퀘스트 저장 API 엔드포인트
          { quests: editableQuests },  // 수정된 퀘스트 배열을 전송
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (response.status === 200) {
          console.log('퀘스트 저장 성공');
          setStep(4);  // 다음 단계로 이동
        } else {
          console.error('퀘스트 저장 실패:', response.statusText);
        }
      } else {
        setStep(4);  // 지정된 퀘스트는 저장 없이 바로 다음 단계로 이동
      }
    } catch (error) {
      console.error('퀘스트 저장 중 오류 발생:', error);
    }
  };
  //////////////////////////////////////////////// 다음으로 버튼 2 (사용자 맞춤형 퀘스트를 생성하고 나서 값 저장하기) 끝. 

  //// 퀘스트 선택
    // 각 유형에서 랜덤으로 퀘스트를 선택하는 함수
// 각 유형에서 랜덤으로 퀘스트를 선택하는 함수
const getRandomQuest = (skill) => {
  let quests = [];
  let selectedQuestName = '';  // 퀘스트 한국어 이름을 담을 변수
  switch (skill) {
    case 'physical_skills':
      quests = ['연극하기', '자전거타기', '수영하기', '구기운동하기', '스트레칭하기', '댄스나 율동 익히기', '조깅하기', '계단 오르내리기', '50M달리기', '등산하기'];
      break;
    case 'dexterity_skills':
      quests = ['뜨개질하기', '컴퓨터 분해하고 조립하기', '그림그리기', '일상용품 만들기', '캘리그래피 하기', '종이접기','흙으로 도자기 만들기','음식 만들기', '액세서리 만들기','선물 포장하기']; 
      break;
    case 'spatial_perception_skills':
      quests = ['약도 이용하여 길찾기','앞면보고 옆, 뒤, 밑면 그리기','사물 그리기','지도 그리기','그림자 모양 유추하기','입체도형의 전개도 그리기','무게의 중심점을 찾아 균형 맞추기','퍼즐 맞추기','3차원 조각 맞추기','별의 위치 찾기']; 
      break;
    case 'musical_skills':
      quests = ['상황에 적합한 음악 선정해보기','작사 작곡하기','오페라 듣기','화음 맞춰보기','학습내용 노래로 만들어 보기','음악을 듣고 그대로 연주하기','음악을 듣고 악기 구별해보기','명곡 감상하기','비트 만들기','악기 연주하기']; 
      break;
    case 'creativity_skills':
      quests = ['자율 연기 하기','제품을 보며 아이디어 추가','어떤 한 교과에서 쓰이는 원리를 다른 교과에 적용하기','아이디어를 기록하는 창의노트 만들기','서로 관련없는 그림이나 문장 및 단어 등으로 이야기 만들기','소설 끝 부분 창작하기','한 가지 주제에 대해 아이디어 쏟아내기','아이디어 단순화 하기','사진 찍어 동화책 만들기','하나의 사물을 다른 용도로 변형 시켜보기']; 
      break;
    case 'linguistic_skills':
      quests = ['강의 듣고 요약하기','독서 감상문 기록하기','보고서 기록하기','뉴스 한 토막을 통하여 신문기사 작성하기 ','토론하기','친구에게 영화나 책의 줄거리 이야기 하기','글 분석하기','여러 가지 언어 비교해 보기 ','어려운 단어 쉽게 설명하기','주제 단어를 제시하고 관련된 마인드맵 작성하기']; 
      break;
    case 'logical_skills':
      quests = ['주변상황에서 일어날 수 있는 사건의 확률 계산하기','일상생활에서 수학적 원리 알아내기','수학토론 하기','추리소설 읽기','나열된 숫자나 그림의 규칙 찾기','주어진 문제 해결 과정을 살펴보고 오류 발견하기','도표 만들기','그래프 분석하기','삼단논법 만들기','이미 일어난 사건들을 통하여 앞으로 일어날 사건 유추하기']; 
      break;
    case 'self_reflection_skills':
      quests = ['명상하기','하루를 마무리하는 일기 쓰기 ','내 행동이나 가치관이 보편적인 도덕적 기준에 맞는지 생각하기','다른 사람에게 나에 대한 피드백 받기','자신의 상황과 가장 비슷한 처지에 있는 소설(혹은 드라마, 영화) 속 인물을 찾아 대응 방식 확인하기','매일 해야 할 일들을 실천하고 확인하기','장단기 목표 세우고 실천하기','회피하고 싶은 감정을 겉으로 드러내어 해결방법 찾아보기','자기 관리 10계명 만들기','평소에 꾸준히 자신의 장, 단점 노트 작성하기']; 
      break;
    case 'interpersonal_skills':
      quests = ['친구끼리 칭찬하기','봉사활동하기','공동 작업하기 ','자신의 행동이나 말에 따라 달라지는 사람들의 반응 살피기','돌아가면서 모둠 활동에서 조장 역할하기','상대의 관심사를 분석하고 그에 맞는 이야깃거리 찾아 대화하기']; 
      break;
    case 'enviromental_friendliness_skills':
      quests = ['동,식물과 인간과의 관계 알아보기', '환경단체 활동 해보기', '쓰레기를 재활용 할 수 있는 방법 생각해보기', '동.식물 특징 파악하기', '동,식물이름 찾아보기','환경오염에 대한 공부하기','동.식물을 길러보고 일지 기록하기','동.식물 분류하기','기온의 변화에 따른 주변 식물들을 관찰하여 사진을 찍고 느낌 기록하기','친구들과 같은 화분을 길러보고 시기별로 비교해보기']; 
      break;
    case 'artistic_visual_skills':
      quests = ['수업내용 그림으로 표현하기','주위 사람들에게 가장 잘 어울리는 색깔 찾아주기','미술 작품 감상하기','독서 내용을 그림으로 표현하기','교실에 있는 물건을 최대한 활용하여 연극에 필요한 소품 만들기','1분 동안 대상을 관찰한 뒤 기억력을 바탕으로 그대로 그려내기','개성을 표현하여 패션쇼 하기','사물 디자인하기','공간 인테리어 바꾸어보기','다른 사람의 패션 코디해주기']; 
      break;
    default:  
      console.log(`Unknown skill type: ${skill}`);
      return null;
  }

  // 랜덤으로 퀘스트 선정
  if (quests.length > 0) {
    const randomIndex = Math.floor(Math.random() * quests.length);
    const selectedQuest = quests[randomIndex];
    console.log(`선정된 퀘스트: ${selectedQuest}`);  // 콘솔에 랜덤으로 선정된 퀘스트 출력
    return selectedQuest;  // 한글로 선정된 퀘스트 반환
  } else {
    return null;
  }
};

  // 상위 3가지 유형을 로드하여 각 유형에서 랜덤 퀘스트 선택
  useEffect(() => {
    if (topSkills.length > 0) {
      const selectedQuests = topSkills.map(skill => {
        const randomQuest = getRandomQuest(skill);
        return {
          type: skill,  // 스킬 유형
          quest: randomQuest || '퀘스트 제목 없음',  // 랜덤 퀘스트의 제목 (없을 경우 기본값)
        };
      });
  
      setSelectedQuests(selectedQuests);  // 선택된 퀘스트 저장
      console.log('Selected quests:', selectedQuests); // 콘솔에 선택된 퀘스트 목록 출력
    }
  }, [topSkills]);

////////// 백엔드 GPT 요청 보내기

  // 백엔드로 GPT 요청을 보내는 함수
  const sendGPTQuestLogToBackend = async () => {
    const token = localStorage.getItem('accessToken');
    try {
      const response = await axios.post(
        `${apiUrl}/quest/gpt_create_quest/`, // GPT 로직과 연결된 API 엔드포인트
        {
          goal: goal, // 사용자가 입력한 목표를 전송
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
  
      if (response.status === 200) {
        const questData = response.data; // GPT로부터 받은 데이터
        console.log('GPT 응답 데이터:', questData);
  
        setQuestDetails(questData.quests);  // GPT 응답 데이터를 questDetails 상태에 저장
        setEditableQuests(questData.quests); // 수정 가능한 퀘스트 저장
        setIsLoading(false);  // 로딩 종료
        setStep(3);  // 결과 페이지로 이동
      } else {
        console.error('퀘스트 생성 실패:', response.statusText);
        setIsError(true);  // 오류 발생 상태 활성화
      }
    } catch (error) {
      console.error('퀘스트 생성 중 오류 발생:', error);
      setIsError(true);  // 오류 발생 상태 활성화
      setIsLoading(false);  // 로딩 종료
    }
  };











  return (
    <div className={styles.container}>
      <HeaderSection title="퀘스트 생성" onBack={handleBackClick} />
      
    {/* 뒤로 가기 모달 */}
    {showExitModal && (
      <div className={styles.modalBackdrop}>
        <div className={styles.modalContent}>
          {/* 조건에 따라 제목과 설명 변경 */}
          <h2 className={styles.modalTitle}>
            {showCreatePage
              ? "퀘스트 생성을 그만두시겠습니까?"
              : "정말 페이지를 떠나실 건가요?"}
          </h2>
          <p className={styles.modalDescription}>
            {showCreatePage ? (
              "이전 페이지로 돌아가면 생성 작업이 취소됩니다."
            ) : (
              <>
                현재 진행 중인 내용이 모두 초기화됩니다. <br />
                그래도 그만 두시겠어요?
              </>
            )}
          </p>
          <div className={styles.modalButtons}>
            <button
              className={styles.leftButton}
              onClick={() => {
                setShowExitModal(false); // 모달 닫기
                if (showCreatePage) {
                  // 1.5 페이지인 경우
                  console.log("Before reset: ", goal); // 초기화 전 상태 확인
                  setGoal(""); // 상태 초기화
                  console.log("After reset: ", goal); // 초기화 후 상태 확인
                  setShowCreatePage(false); // 1번 페이지로 돌아가기
                  navigate("/create_quest"); // create_quest로 이동
                } else {
                  // 2번 페이지나 다른 페이지의 경우
                  navigate("/questpage"); // questpage로 이동
                }
              }}
            >
              네. <br /> 그만할래요.
            </button>
            <button
              className={styles.rightButton}
              onClick={() => setShowExitModal(false)} // 모달 닫기
            >
              아니요. <br /> 계속할래요.
            </button>
          </div>
        </div>
      </div>
    )}

      
      {step === 1 && !showCreatePage &&  (  // 1단계: 목표 입력 화면
        <div className={styles.content}>
          <h2 className={styles.contenth2}>글로를 위한 <br /> 퀘스트 내용이에요!</h2>
          <p>
            진단검사 결과를 바탕으로, <br />추천하는 퀘스트예요!
            <br></br>
            <br></br>
            21일동안 해당 활동에 대한 퀘스트를 수행할 거예요!<br/>
            새로고침할 때마다 새로운 퀘스트를 추천할게요!
          </p>
          {/* <div className={styles.inputContainer}>
            <p className={styles.inputContainerPtag}>퀘스트 목표</p>
            <input
              className={styles.input}
              type="text"
              placeholder="퀘스트 목표"
              value={goal}
              onChange={handleInputChange}
              disabled={isInputDisabled}
            />
          </div> */}

          {selectedQuests.length > 0 && (
            <div className={styles.buttonGroup}>
              {selectedQuests.map((quest, index) => (
                <button
                  key={index}
                  className={selectedTag === quest.quest ? styles.tagButtonSelected : styles.tagButton}
                  onClick={() => handleTagClick(quest.quest === selectedTag ? null : quest.quest)} // 이미 선택된 태그 클릭 시 선택 해제
                >
                  {quest.quest} {/* 한국어로 변환된 퀘스트 이름을 출력 */}
                </button>
              ))}
            </div>
          )}

          <div className={styles.createQuestLink}>
                <p className={styles.createQuestLinkp}>혹시 원하는 퀘스트가 없나요?</p>
                <p className={styles.createQuestLinkp}>생성형 인공지능으로 퀘스트를 생성할 수 있어요!</p>
                <button
                  className={styles.createQuestButton}
                  onClick={() => 
                    {
                      setGoal(""); // goal 상태 초기화
                      setShowCreatePage(true)} // 생성 페이지로 이동
                    }
                    
                >
                  맞춤형 퀘스트 생성하러 가기
                </button>
              </div>

          <div className={styles.nextButtonContainer}>
            <button
              className={goal ? styles.nextButtonActive : styles.nextButton}
              onClick={handleNextClick}
              disabled={!goal}
            >
              다음으로
            </button>
          </div>
        </div>
      )}

      {step === 1 && showCreatePage && (
        // 생성 페이지
        <div className={styles.content}>
          <h2 className={styles.contenth2}>글로는 <br/>어떤 목표를 이루고 싶으신가요?</h2>
          <p>입력한 활동을 퀘스트 형식으로 변환해서<br/>
          21일간 매일 수행할 수 있도록 도울게요!
          </p>

          {/* <input
            type="text"
            placeholder="목표를 입력하세요"
            value={goal}
            onChange={(e) => setGoal(e.target.value)}
          /> */}
          <div className={styles.inputContainer}>
            <p className={styles.inputContainerPtag}>퀘스트 목표</p>
            <input
              className={styles.input}
              type="text"
              placeholder="책 읽기"
              value={goal} // goal 상태 연결
              onChange={(e) => setGoal(e.target.value)} // 입력 변경 처리
              disabled={false} // 항상 활성화 상태
            />
          </div>
          <p>활동 내용이 구체적일 수록 좋아요!</p>

          
          <div className={styles.nextButtonContainer}>
            <button
              className={goal ? styles.nextButtonActive : styles.nextButton}
              onClick={handleNextClick}
              disabled={!goal}
            >
              다음으로
            </button>
          </div>

        </div>

        
      )}

      {step === 2 && (  // 2단계: 로딩 화면
        <div className={styles.loadingContainer}>
          <h2 className={styles.loadingTitle}>글로의 멋진 성장을 위해서 <br />퀘스트를 생성하는 중이에요!</h2>
          <p className={styles.loadingDescription}>21동안 퀘스트를 멋지게 수행할 수 있도록<br />열심히 도울게요!</p>
          <div className={styles.circleContainer}>
            <img src={loading} alt="그룹이미지" className={styles.circleImage} />
          </div>
        </div>
      )}

{step === 3 && (  // 3단계: 결과 화면
  <div className={styles.content}>

    {isError ? (
          // 250114 퀘스트 생성 중 오류 내용 확인 시 예외 처리 진행
          // 오류 발생 시 렌더링될 내용
          <div>
            <h2 className={styles.contenth2}>퀘스트 생성 중 잠깐 문제가 발생했습니다.</h2>
            <p>잠시 후 다시 시도해 주세요!</p>

            <div>
              {/* 여기에 이미지 넣으면 될 듯  */}
            </div>



            <div className={styles.nextButtonContainer}>
              <button
                // className={styles.retryButton}
                className={styles.nextButtonActive}  // 항상 활성화된 상태로 변경
                onClick={() => {
                  setIsError(false);  // 오류 상태 초기화
                  setStep(1);         // Step 1로 돌아감
                  setShowCreatePage(true);  // 생성 페이지 닫기
                }}
              >
                재시도하기
              </button>
            </div>
          </div>
        ) : (
          // 정상적인 결과 화면
      <>


  
    <h2 className={styles.contenth2}>퀘스트 내용을 확인해 주세요!</h2>
    

    {/* GPT로 생성된 퀘스트는 주황색 제목과 함께 수정 가능 */}
    {isGptQuest ? (
      <div>
        {/* <p>앞으로 진행될 {questDetails.length}일차의 퀘스트 내용이에요!<br />나머지는 진행하면서 알려드릴게요!</p> */}
        <p>앞으로 진행될 21일차의 퀘스트 내용이에요!<br />이 페이지에서만 수정이 가능합니다!</p>
        <h3 className={styles.questTitle} style={{ color: "orange" }}>{questTitle}</h3>
        <div className={styles.questmap}>
          {editableQuests && editableQuests.length > 0 ? (
            editableQuests.map((detail, index) => (
              <div key={index} className={styles.questDetail}>
                <h4>{index + 1}일 차 : {detail.title}</h4>
                <textarea
                  value={detail.description || ''}  // 설명 수정 가능
                  onChange={(e) => handleQuestEdit(index, 'description', e.target.value)}
                  placeholder="설명"
                  className={styles.description}
                />
              </div>
            ))
          ) : (
            <p>수정 가능한 퀘스트가 없습니다.</p>
          )}
        </div>
      </div>
    ) : (
      <div>
        {/* 지정퀘스트 */}
        <p>앞으로 진행될 {questDetails.length}일차의 퀘스트 내용이에요!<br />나머지는 진행하면서 알려드릴게요!</p>
        <h3 className={styles.questTitle}>{questTitle}</h3>
        <div className={styles.questmap}>
          {questDetails.slice(0, 3).map((detail, index) => (  // 첫 3개의 퀘스트만 보여줌
            <div key={index} className={styles.questDetail}>
              <h4>{index + 1}일 차 : {detail.title}</h4>
              <p>{detail.description}</p>
            </div>
          ))}
        </div>
      </div>
    )}

    <div className={styles.nextButtonContainer}>
      <button
        // className={goal ? styles.nextButtonActive : styles.nextButton}
        className={styles.nextButtonActive}  // 항상 활성화된 상태로 변경
        onClick={handleNextClick}
      >
        다음으로
      </button>
    </div>
    </>
    )}
  </div>
)}



      {step === 4 && (  // 3단계: 결과 화면

      // <div className={styles.container}>
      <div className={styles.content}>

      <h2 className={styles.title}>더 멋진 글로가 되기!</h2>
      <p className={styles.subtitle}>21일 뒤에 다시 만나요!</p>

      <div className={styles.circleContainer}>
        <img src={Group_of_characters} alt="그룹이미지" className={styles.circleImage} />
      </div>

      <div className={styles.nextButtonContainer}>
        <button className={styles.nextButtonActive} onClick={handleFinishClick}>
          종료하기
        </button>
      </div>
    </div>

      )}

    </div>
  );
};
export default QuestCreatePage;
